var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task',{attrs:{"type":1,"keyID":"E4AE84A5352D1812580450ADC067D99A"}})}
var staticRenderFns = []

export { render, staticRenderFns }